
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security/aws",
      function () {
        return require("private-next-pages/security/aws/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/security/aws"])
      });
    }
  